import { watch } from 'vue'

import { useChatStore } from '@/stores/chat.store'

export const useConfirmedChatActions = (servicePrefix, onConfirmed) => {
  const chatStore = useChatStore()
  watch(() => chatStore.lastConfirmedActions, ({ paths }) => {
    if (paths.some(path => path.startsWith(servicePrefix))) onConfirmed()
  })
}
